import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const offers = [
    { text: "Complimentary luxury gift on all orders", link: "/offers" },
    { text: "New botanical rituals now live", link: "/shop" },
    { text: "Discover KROMAIC luxury gift sets", link: "/gift-sets" },
    { text: "Free shipping on premium orders", link: "/about" },
];

const CurvedOfferLoop = () => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <motion.div
            className={`fixed top-0 left-0 right-0 z-[60] overflow-hidden border-b transition-all duration-500 ${
                isScrolled
                    ? "bg-white/100 backdrop-blur-md border-nude"
                    : "bg-ivory/70 border-transparent"
            }`}
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            {/* Edge fade */}
            <div className="pointer-events-none absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-ivory to-transparent z-10" />
            <div className="pointer-events-none absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-ivory to-transparent z-10" />

            <motion.div
                className="relative flex items-center gap-14 py-2 whitespace-nowrap"
                animate={{ x: ["0%", "-50%"] }}
                transition={{
                    repeat: Infinity,
                    duration: 40,
                    ease: "linear",
                }}
            >
                {[...offers, ...offers].map((item, i) => (
                    <Link key={i} to={item.link} className="group">
                        <motion.div
                            whileHover={{ y: -2, scale: 1.02 }}
                            className="flex items-center gap-6 text-[10px] md:text-xs tracking-[0.35em] uppercase font-medium text-charcoal/70 hover:text-charcoal transition-colors"
                        >
                            <span>{item.text}</span>
                            <span className="w-6 h-[1px] bg-gradient-to-r from-transparent via-champagne/70 to-transparent" />
                        </motion.div>
                    </Link>
                ))}
            </motion.div>
        </motion.div>
    );
};

export default CurvedOfferLoop;
